import {isClientEntityOperational} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreatePlanNode} from "../view-model";

export const operationalNodesAreImmutable = (node: CreatePlanNode): void => {
  if (isClientEntityOperational(node.source)) {
    node.immutable = true;
  }
  node.children.forEach(operationalNodesAreImmutable);
};
